import React, { useRef, useState } from "react";
import DownloadList from "@bmi-digital/components/download-list";
import DocumentSimpleTableResults from "../../../components/DocumentSimpleTableResults";
import DocumentResultsFooter from "../../../components/DocumentResultsFooter";
import { useConfig } from "../../../contexts/ConfigProvider";
import { StyledDocumentsWrapper } from "../../../components/styles/ProductLeadBlock.styles";
import type { Product } from "../../../types/pim";
import type { DocumentDisplayFormatType } from "../../../components/Resources";

const DOCUMENTS_PER_PAGE = 24;
const ProductDocuments = ({
  productDocuments,
  documentDisplayFormat
}: {
  productDocuments: Product["productDocuments"];
  documentDisplayFormat?: DocumentDisplayFormatType | null;
}) => {
  const [documents, setDocuments] = useState(productDocuments.slice(0, 24));
  const [page, setPage] = useState(1);
  const resultsElement = useRef<HTMLDivElement>(null);

  const { documentDownloadMaxLimit } = useConfig();
  const pagesCount = Math.ceil(productDocuments.length / DOCUMENTS_PER_PAGE);
  const displayBy = documentDisplayFormat === "Asset name" ? "title" : "type";

  const handlePageChange = (_: React.ChangeEvent, page: number) => {
    const scrollY = resultsElement.current!.offsetTop - 200; //resultsElement.current is always defined at this stage
    window.scrollTo(0, scrollY);
    setPage(page);
    const startIndex = (page - 1) * DOCUMENTS_PER_PAGE;
    const endIndex = startIndex + DOCUMENTS_PER_PAGE;
    setDocuments(productDocuments.slice(startIndex, endIndex));
  };

  return (
    <StyledDocumentsWrapper ref={resultsElement}>
      <DownloadList maxSize={documentDownloadMaxLimit * 1000000}>
        <DocumentSimpleTableResults
          documents={documents}
          headers={["add", displayBy, "size", "actions"]}
          pageNumber={page}
        />
        <DocumentResultsFooter
          page={page}
          count={pagesCount}
          onPageChange={handlePageChange}
        />
      </DownloadList>
    </StyledDocumentsWrapper>
  );
};

export default ProductDocuments;
